namespace GeniuzPOS.Member {
    export interface MbReport01_DtForm {
        ShopId: Serenity.StringEditor;
        ShopName: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        NetSales: Serenity.DecimalEditor;
    }

    export class MbReport01_DtForm extends Serenity.PrefixedContext {
        static formKey = 'Member.MbReport01_Dt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MbReport01_DtForm.init)  {
                MbReport01_DtForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(MbReport01_DtForm, [
                    'ShopId', w0,
                    'ShopName', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'NetSales', w2
                ]);
            }
        }
    }
}
